import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchWithErrorHandling } from "../utils/service";

export const useFetchAccount = (userInfo) =>
  useQuery({
    queryKey: ["account"],
    queryFn: () => fetchWithErrorHandling("/v1/account"),
    retry: false,
    refetchOnWindowFocus: true,
    enabled: !!!userInfo,
  });

export const useUpdateAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (accountData) =>
      fetchWithErrorHandling("/v1/account/update", {
        method: "PUT",
        body: JSON.stringify(accountData),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account"] });
    },
  });
};

export const useResendVerificationEmail = () => {
  return useMutation({
    mutationFn: () =>
      fetchWithErrorHandling("/v1/account/resend-verification-email", {
        method: "POST",
      }),
  });
};

export const useUpdatePassword = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (passwordData) =>
      fetchWithErrorHandling("/v1/account/update-password", {
        method: "PUT",
        body: JSON.stringify(passwordData),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account"] });
    },
  });
};

export const useUpdatePreferences = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (preferencesData) =>
      fetchWithErrorHandling("/v1/account/update-preferences", {
        method: "PUT",
        body: JSON.stringify(preferencesData),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account"] });
    },
  });
};

export const useDeleteAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      fetchWithErrorHandling("/v1/account/delete", {
        method: "DELETE",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account"] });
    },
  });
};

export const useLinkOAuthAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (oauthData) =>
      fetchWithErrorHandling("/v1/account/link-oauth", {
        method: "POST",
        body: JSON.stringify(oauthData),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account"] });
    },
  });
};

export const useUnlinkOAuthAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      fetchWithErrorHandling("/v1/account/unlink-oauth", {
        method: "DELETE",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account"] });
    },
  });
};

// Direct account fetch for subscription polling that doesn't trigger logout
export const fetchAccountDirect = async () => {
  try {
    return await fetchWithErrorHandling("/v1/account", {
      skipAuthErrorHandling: true,
    });
  } catch (error) {
    console.error("Error fetching account:", error);
    return null;
  }
};
